module.exports = __webpack_public_path__ + "static/media/laptop_blank.d5f5322d.png";